<div class="newmessage" style="display: flex;">
  <textarea placeholder="{{ placeholderText }}" #newMessageArea
            [(ngModel)]="message"
            (keydown)="processInput($event, newMessageArea.selectionStart)"></textarea>
  <button (click)="sendMessage()">
    <img style="vertical-align: middle" src="../../assets/icon_upload.svg"/>
  </button>
</div>
